import { Alert, Box, CircularProgress, createTheme, FormControl, InputLabel, Modal, Snackbar, TextField, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import Lista from "../../components/Lista";
import servConsultaAcesso from "../../services/login/servConsultaAcesso";
import { logout } from "../../state/slices/userSlice";
import { style as modalStyle } from "../../components/Loading/Loading";
import { columnsConsulta } from "./Lista";
import "./style.css";
import { Popup } from "../../components/Popup/Popup";
import { PopupExtraG } from "../../components/Popup/PopupExtraG";
import Cadastro from "./Cadastro";
import { ErrorHandling } from "../../components/Errors/Errors";
import { WhiteInput } from "../../components/Inputs/InputText";
import SolicitacaoAnalise from "./SolicitacaoAnalise";
import ArquivarConsulta from "./ArquivarConsulta";
import ResultadoAnalise from "./ResultadoAnalise";
import ResultadoArquivamento from "./Arquivamento";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { OpcoesSituacaoConsulta } from "../../components/Combobox/SituacaoConsulta";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import Select from 'react-select';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { OpcoesPeriodoDatas } from "../../components/Combobox/PeriodoDatas";
import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import servFileIni from "../../services/login/servFileIni";

const ConsultaDeAcesso = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user);

    const [filtro, setFiltro] = useState('');
    const [situacaoConsulta, setSituacaoConsulta] = useState([]);

    const [tipoPeriodo, setTipoPeriodo] = useState(null);
    const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
    const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
    const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());

    const [consultas, setConsultas] = useState([]);
    const [podeVisualizarAnalise, setPodeVisualizarAnalise] = useState(false);
    const [podeVisualizarArquivamento, setPodeVisualizarArquivamento] = useState(false);
    
    const [openCadastro, setOpenCadastro] = useState(false);
    const [eNovoCadastro, setENovoCadastro] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null);

    const [openAnalise, setOpenAnalise] = useState(false);
    const [openArquivamento, setOpenArquivamento] = useState(false);
    const [openVisualizarAnalise, setOpenVisualizarAnalise] = useState(false);
    const [openVisualizarArquivamento, setOpenVisualizarArquivamento] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);

    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color: "#d2d4d2"
                    }
                }
            }
        }
    });

    // #region Use effects
    useEffect(() => {
        const recuperarDados = async (filtroDatas) => {
            try {
                setIsLoading(true);

                let dados;
            
                // Se não tiver situação ou data informada, faz o listar básico, só com a pesquisa geral
                if(!filtroDatas) {
                    dados = await servConsultaAcesso.listar(user.codigoUsuario, "");
                } else {
                    let arraySituacoes = [];

                    arraySituacoes = situacaoConsulta.map((item) => item.value);

                    dados = await servConsultaAcesso.listarCfeSituacaoOuData(user.codigoUsuario, 
                                                                            filtro, 
                                                                            arraySituacoes, 
                                                                            tipoDataFiltro,
                                                                            filtroDatas.dataInicial,
                                                                            filtroDatas.dataFinal);
                }

                let content =  dados.Content?.Content;

                if(dados.Content.Total === 0) {
                    setIsLoading(false);
                    return;
                }

                content && content.map((consulta) => {
                    return consulta.id = consulta.Id
                });
  
                setIsLoading(false);
                
                setConsultas(content);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status, 
                    err?.Message, 
                    setOpenError, 
                    setErrorMessage, 
                    dispatch, 
                    logout, 
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const recuperarUltimoTipoPeriodoDefinido = async () => {
            try {
                setIsLoading(true);

                let dto = {
                    CodigoUsuario: user.codigoUsuario.toString(),
                    CodigoSecao: "TIPO_PERIODO_P3",
                    Chave: "IDTIPOPERIODOCONSULTAACESSO",
                    Conteudo: ""
                };

                let response = await servFileIni.Recuperar(dto);
                let novasDatas;

                // Se tiver um perí­odo já salvo no FileIni, ele é recuperado
                // Se não, ele seta o tipo default (este mês)
                if(response.Content.trim() !== "") {
                    let conteudo = Number(response.Content);
                    let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;
                    
                    await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
                    novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
                } else {
                    await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
                    novasDatas = retornaDatasCfeTipoPeriodo(8); // 8 - Este mês
                }

                if (consultas.length === 0) {
                    await recuperarDados(novasDatas);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status, 
                    err?.Message, 
                    setOpenError, 
                    setErrorMessage, 
                    dispatch, 
                    logout, 
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        recuperarUltimoTipoPeriodoDefinido();
    }, []);

    useEffect(() => {
            if (recordForEdit === null) {
                setPodeVisualizarAnalise(false);
                setPodeVisualizarArquivamento(false);
                return
            }
    
            let situacao = recordForEdit?.Situacao || (recordForEdit?.row?.Situacao ?? 0);

            const situacoesAnalisadas = [2];
            const situacoesArquivadas = [4];
    
            situacoesAnalisadas.includes(situacao) ? setPodeVisualizarAnalise(true) : setPodeVisualizarAnalise(false);
            situacoesArquivadas.includes(situacao) ? setPodeVisualizarArquivamento(true) : setPodeVisualizarArquivamento(false);
    }, [recordForEdit]);
    // #endregion

    // #region Pesquisar
    const onClickPesquisar = async () => {
        try {
            setIsLoading(true);
            let dados;
            
            // Se não tiver situação ou data informada, faz o listar básico, só com a pesquisa geral
            if(situacaoConsulta.length === 0 && 
              (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") && 
              (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
                dados = await servConsultaAcesso.listar(user.codigoUsuario, filtro);
            } else {
                let arraySituacoes = [];
                
                arraySituacoes = situacaoConsulta.map((item) => item.value);

                dados = await servConsultaAcesso.listarCfeSituacaoOuData(user.codigoUsuario, 
                                                                         filtro, 
                                                                         arraySituacoes, 
                                                                         tipoDataFiltro,
                                                                         dataInicialFiltro,
                                                                         dataFinalFiltro);
            }

            let content = dados?.Content?.Content;

            content.map((consulta) => {
                return consulta.id = consulta.Id
            });

            setIsLoading(false);

            setConsultas(content);

            if (content.length === 0) {
                setErrorMessage("Não foram encontrados registros para sua pesquisa");
                setOpenError(true);
            }
        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.response?.status, 
                err?.Message, 
                setOpenError, 
                setErrorMessage, 
                dispatch, 
                logout, 
                navigate,
                err?.response?.data?.Message
            );
        }
    }
    // #endregion

    // #region AdicionarOuEditar
    const adicionarOuEditar = async (Consulta) => {
        let id;
    }
    // #endregion

    // #region Métodos para abrir/visualizar outras telas/popups
    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const adicionarNovaConsulta = () => {
        setENovoCadastro(true);
        //setRecordForEdit(null);
        setOpenCadastro(true);
    }

    const solicitarAnalise = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        const situacoesHomologaveis = [0];

        if (situacoesHomologaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            return setOpenAnalise(true);
        }

        setErrorMessage("Só é possível solicitar análise de consultas com situação em digitação")
        return setOpenError(true);
    }

    const solicitarArquivamento = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        const situacoesHomologaveis = [0];

        if (situacoesHomologaveis.includes(recordForEdit?.row?.Situacao)
            || situacoesHomologaveis.includes(recordForEdit?.Situacao)) {
            return setOpenArquivamento(true);
        }

        setErrorMessage("Só é possí­vel arquivar consultas com situação em digitação");
        return setOpenError(true);
    }

    const visualizarAnalise = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        return setOpenVisualizarAnalise(true);
    }

    const visualizarArquivamento = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro")
            return setOpenError(true);
        }

        return setOpenVisualizarArquivamento(true);
    }
    // #endregion

    const handleTipoDataFiltro = (event) => {
        event.preventDefault();

        setTipoDataFiltro(event.target.value)
    }

    const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
        try {
            setTipoPeriodo(tipoPeriodo);

            let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
            setDataInicialFiltro(datasCalculadas.dataInicial);
            setDataFinalFiltro(datasCalculadas.dataFinal);

            let dto = {
                Chave: "IDTIPOPERIODOCONSULTAACESSO",
                Conteudo: tipoPeriodo.value.toString(),
                CodigoSecao: "TIPO_PERIODO_P3",
                CodigoUsuario: user.codigoUsuario.toString()
            };

            await servFileIni.Inserir(dto);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
            setOpenError(true);
            return;
        }
    }

    return (
        <div className="consultas-container">
            <div className="consultas-filtros">
                <FormControl variant="outlined">
                    <InputLabel htmlFor="pesquisa-nome" shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >
                        Pesquisa geral<FontAwesomeIcon title="Este campo pesquisa por: código do orçamento estimado, protocolo, nome, UC ou inscrição." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} />
                    </InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-nome" sx={{ width: "500px", margin: '0px 18px' }} />
                </FormControl>
                <FormControl variant="outlined" sx={{ width: "380px", marginRight: "20px" }}>
                    <InputLabel htmlFor="pesquisa-nome-situacao" shrink style={{ color: "#B8B8B8" }}>
                        Situação
                    </InputLabel>
                    <Select     
                        isMulti={true}
                        value={situacaoConsulta}
                        onChange={value => setSituacaoConsulta(value)}
                        options={OpcoesSituacaoConsulta}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
            </div>
            <div className="consultas-filtros">
                <FormControl variant="outlined">
                    <InputLabel htmlFor="data-consulta" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
                        <select className="tipo_data_filtro_consulta" name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
                            <optgroup>
                                <option className="tipo_data_filtro_consulta_opt" value="data-cadastro" selected>Data cadastro</option>
                                <option className="tipo_data_filtro_consulta_opt" value="data-envio-homolog">Data envio homolog.</option>
                            </optgroup>
                        </select>
                    </InputLabel>
                
                    <div className="consulta-acesso-datas">
                        <Select
                            value={tipoPeriodo}
                            onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
                            options={OpcoesPeriodoDatas}
                            styles={SearchFieldStylesFiltro}
                            placeholder="Perí­odo"
                        />
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicialFiltro}
                                    onChange={(e) => setDataInicialFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#707070"}} />
                                            <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: { actions: ["today"] },
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                        <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataFinalFiltro}
                                    onChange={(e) => setDataFinalFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#707070"}} />
                                            <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: { actions: ["today"] },
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </div>
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginBottom: '22px' }}>
                    Pesquisar
                </BlueHoverButton>
            </div>

            <div className="consultas-botoes">
                <BlueHoverButton variant="contained" onClick={adicionarNovaConsulta}>Novo orçamento</BlueHoverButton>
                <BlueHoverButton variant="contained" onClick={solicitarAnalise}>Solicitar análise</BlueHoverButton>
                { podeVisualizarAnalise && (
                    <BlueHoverButton variant="contained" onClick={visualizarAnalise} >Visualizar análise</BlueHoverButton>
                ) }
                <BlueHoverButton variant="contained" onClick={solicitarArquivamento}>Arquivar</BlueHoverButton>
                { podeVisualizarArquivamento && (
                    <BlueHoverButton variant="contained" onClick={visualizarArquivamento} >Arquivamento</BlueHoverButton>
                ) }
            </div>

            <div className="consultas-lista">
                <Lista columns={ columnsConsulta } rows={ consultas } setSelectedData={setRecordForEdit} onDblClick={setOpenCadastro} hideFooter={false} autoHeight={false} />
            </div>
            <PopupExtraG 
                title="Orçamento estimado"
                openPopup={openCadastro} 
                setOpenPopup={setOpenCadastro} 
                novoCadastro={eNovoCadastro}
                setNovoCadastro={setENovoCadastro}
            >
                <Cadastro 
                    addOrEdit={adicionarOuEditar}
                    pesquisar={onClickPesquisar}
                    recordForEdit={recordForEdit}
                    setOpen={setOpenCadastro}
                    novoCadastro={eNovoCadastro}
                    setEhNovoCadastro={setENovoCadastro}
                />
            </PopupExtraG>
            
            <Popup title="Orçamento de conexão" openPopup={openAnalise} setOpenPopup={setOpenAnalise} minHeight="100px">
                <SolicitacaoAnalise 
                    setOpenPopup={setOpenAnalise}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>
            <Popup title="Arquivar orçamento estimado" openPopup={openArquivamento} setOpenPopup={setOpenArquivamento} minHeight="100px">
                <ArquivarConsulta 
                    setOpenPopup={setOpenArquivamento}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>
            <Popup title="Visualizar análise" openPopup={openVisualizarAnalise} setOpenPopup={setOpenVisualizarAnalise} minHeight="100px">
                <ResultadoAnalise 
                    setOpenPopup={setOpenVisualizarAnalise}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>
            <Popup title="Arquivamento" openPopup={openVisualizarArquivamento} setOpenPopup={setOpenVisualizarArquivamento} minHeight="100px">
                <ResultadoArquivamento
                    setOpenPopup={setOpenVisualizarArquivamento}
                    recordForEdit={recordForEdit}
                    pesquisar={onClickPesquisar}
                />
            </Popup>
            <Modal open={isLoading}>
                <Box style={modalStyle} >
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError} >
                <Alert onClose={handleCloseError} severity="error" sx={{ width: "100%" }} >
                    {errorMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export { ConsultaDeAcesso };